import apiClient from './axiosInstance'

const headers = (token) => {
  return { headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  }}
}

export default {
  getPayouts (token) {
    return apiClient.get('/payout/get/all', headers(token));
  },
  getPayout (token, id) {
    return apiClient.get(`/payout/${id}`, headers(token))
  },
  postPayout (token, payout) {
    return apiClient.post('/payout/create', payout, headers(token))
  },
  editPayout (token, payoutId, payoutDataToUpdate) {
    return apiClient.patch(`/payout/edit/${payoutId}`, payoutDataToUpdate, headers(token))
  },
  deletePayout (token, payoutIdToDelete) {
    return apiClient.delete(`/payout/delete/${payoutIdToDelete}`, headers(token))
  },
  // /delete_907867563/:id
  // deleteAllPayouts(token, payoutIdToDelete) {
  //   return apiClient.delete(`/payout/delete/${payoutIdToDelete}`, headers(token))
  // },
  // https://kehillah-fleet-api.herokuapp.com/api/payout/delete_907867563/NANA_OC
  // https://kehillah-fleet-api.herokuapp.com/api/slack/slack.get.driver.summary/0555910541
  // https://kehillah-fleet-api.herokuapp.com/api/slack/slack.get.driver.summaryForSMS/0555910541
}
